// removed by extract-text-webpack-plugin
module.exports = {"mainContainer":"_1SfbVuKtffNrsmsN1Z67J","initialContainer":"_2IkAW6l6dnRqV-6bCWyAZM","initialContainerDarkTheme":"_2RLAqQ57QT7Y19DVg9mzKL","infoContainer":"Vq8Z8Tcpzh_jtyWSW5Fgp","messageContainer":"_3Vi37sJy1npxIPVsG4yPeB"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/chat/chat-messages/message-history/MessageHistory.css
// module id = 265
// module chunks = 0